<template>
  <el-form label-width="100px" class="add-aim-container">
    <el-form-item label="意图名称：">
      <el-input
        v-model="addForm.intent_name"
        placeholder="请输入意图名称"
      ></el-input>
    </el-form-item>
    <el-form-item label="意图类别：">
      <el-select v-model="addForm.cate_code" placeholder="请选择意图类别">
        <el-option
          v-for="item in aimTypes"
          :key="item.id"
          :label="item.cate_name"
          :value="item.cate_code"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="快捷短语：">
      <el-input
        v-model="addForm.keyword"
        placeholder="请输入快捷短语"
      ></el-input>
    </el-form-item>
    <el-form-item label="关联槽值：">
      <el-select
        v-model="addForm.slot_list"
        multiple
        collapse-tags
        style="margin-left: 20px"
        placeholder="请选择槽值"
      >
        <el-option
          v-for="item in slotList"
          :key="item.id"
          :label="item.slot_name"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    props: {
      addForm: Object,
      aimTypes: Array,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        slotList: (state) => state.aimManager.slotList,
      }),
    },
  }
</script>

<style lang="scss">
  .add-aim-container {
    .el-select {
      margin-left: 0 !important;
      width: 100%;
    }
    .el-input {
      width: 80%;
    }
  }
</style>
